<template>
  <div class="lb">
    <div class="photo">
      <div class="text-area" ref="content" @mouseenter="mouseenterEvent()" @mouseleave="mouseleaveEvent()">
        <div class="list-content" ref="scroll1">
          <div class="photo_item" v-for="(item, i) in scopelist" :key="i" v-if="item && item.value1">
            <div class="photo_item-left">
              <img :src="item.value1" alt="" />
              <div class="corner top-left"></div>
              <div class="corner top-right"></div>
              <div class="corner bottom-left"></div>
              <div class="corner bottom-right"></div>
            </div>
            <div class="photo_item-right">
              <div class="title" v-if="item.value2" :title="item.value2">
                <div class="icon"></div>
                <div>{{ item.value2 }}</div>
              </div>
              <div class="main_txt" v-if="item.value3">
                <div>
                  {{ item.value3 }}
                </div>
              </div>
              <div class="time" v-if="item.value4" :title="item.value4">
                <div>{{ item.value4 }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="list-content" ref="scrol21" v-if="scopelist && scopelist.length > 2">
          <div class="photo_item" v-for="(item, i) in scopelist" :key="i" v-if="item && item.value1">
            <div class="photo_item-left">
              <img :src="item.value1" alt="" />
              <div class="corner top-left"></div>
              <div class="corner top-right"></div>
              <div class="corner bottom-left"></div>
              <div class="corner bottom-right"></div>
            </div>
            <div class="photo_item-right">
              <div class="title" v-if="item.value2" :title="item.value2">
                <div class="icon"></div>
                <div>{{ item.value2 }}</div>
              </div>
              <div class="main_txt" v-if="item.value3">
                <div>
                  {{ item.value3 }}
                </div>
              </div>
              <div class="time" v-if="item.value4" :title="item.value4">
                <div>{{ item.value4 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope80",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      title: "scope80-新数值条形图-完成",
      timer: null,
      defaultdata: [
        {
          value1: "http://121.4.173.197:8000/defaultimg/default8.png",
          value2: "示例图片一",
          value3: "示例文本一",
          value4: "备注一",
        },
        {
          value1: "http://121.4.173.197:8000/defaultimg/default9.png",
          value2: "示例图片二",
          value3: "示例文本二",
          value4: "备注二",
        },
        {
          value1: "http://121.4.173.197:8000/defaultimg/default8.png",
          value2: "示例图片三",
          value3: "示例文本三",
          value4: "备注三",
        },
        {
          value1: "http://121.4.173.197:8000/defaultimg/default9.png",
          value2: "示例图片四",
          value3: "示例文本四",
          value4: "备注四",
        },
      ],
      valueMap: [
        { name: "图片地址", key: "value1" },
        { name: "标题文本", key: "value2" },
        { name: "内容文本", key: "value3" },
        { name: "额外备注", key: "value4" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      scopelist: [],
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
          let vlist = Object.keys(item)
          let isdata = false
          vlist.forEach(del => {
            if (item[del] == undefined) {
              item[del] = ''
            } else if (del && item[del]) {
              isdata = true
            }
          })
          if (vlist.length && isdata) return item
        })
        this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      this.Drawdata();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
    rollUp(t) {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (ulf1.offsetHeight > 200) {
        box.scrollTop = 0;
        this.timer = window.setInterval(this.rollStart, t);
      }
    },
    rollStart() {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (box.scrollTop >= ulf1.scrollHeight) {
        box.scrollTop = 0;
      } else {
        box.scrollTop += 2;
      }
    },
    mouseenterEvent() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    mouseleaveEvent(t) {
      if (!this.timer) {
        this.timer = setInterval(this.rollStart, 150);
      }
    },
    Drawdata() {
      let linedata = JSON.parse(JSON.stringify(this.defaultdata));
      linedata = linedata.sort((a, b) => +b.value3 - +a.value3).slice(0, 10);
      this.scopelist = linedata;
    },
  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.setData()
    let host = window.location.host
    if (host == 'www.17886.cn') {
      let news = 'https://www.17886.cn'
      let olds = 'http://121.4.173.197:8000'
      this.defaultdata.forEach(item => {
        if (item.value1 && item.value1.includes(olds)) {
          item.value1 = item.value1.replace(olds, news)
        }
      })
      this.defaultdata = [...this.defaultdata]
    }
    this.Drawdata(); //需要刷新的数据
    this.$nextTick(() => {
      this.rollUp(150);
    });
  },
};
</script>

<style scoped lang="scss">
.lb {
  width: 435px;
  height: 240px;
  padding: 10px 0;
  display: flex;
  position: relative;
  overflow: hidden;

  .photo {
    margin-left: 10px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow: auto;
    // display: flex;
  }

  .photo_item {
    width: 100%;
    height: 108px;
    display: flex;
    margin-top: 20px;
    margin-bottom: 20px;

    .photo_item-left {
      width: 171px;
      height: 108px;
      padding: 2px;
      box-sizing: border-box;
      border: 2px solid #32405e;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .corner {
        background-image: url("@/assets/temimg6/corner.png");
        background-size: cover;
        position: absolute;
        /* 设置为绝对定位 */
        width: 18px;
        /* 设置 div 的宽度 */
        height: 18px;
        /* 设置 div 的高度 */
      }

      .top-left {
        top: -6px;
        left: -6px;
        transform: rotate(90deg);
      }

      .top-right {
        top: -6px;
        right: -6px;
        transform: rotate(-180deg);
      }

      .bottom-left {
        bottom: -6px;
        left: -6px;
        // transform: rotate(-45deg);
      }

      .bottom-right {
        bottom: -6px;
        right: -6px;
        transform: rotate(-90deg);
      }

      img {
        width: 98%;
        height: 98%;
      }
    }

    .photo_item-right {
      margin-left: 14px;

      .title {
        width: 200px;
        height: 32px;
        //纯色到透明的背景渐变
        background: linear-gradient(to right,
            rgba(16, 59, 126, 1),
            rgba(16, 59, 126, 0));
        display: flex;
        align-items: center;

        // justify-content: center;
        .icon {
          margin: 0 8px;
          width: 11px;
          height: 11px;
          background: url("@/assets/temimg6/title-icon.png") no-repeat;
          background-size: 100% 100%;
        }

        >div {
          width: 180px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          line-height: 32px;

          text-shadow: 0px 0px 10px rgba(41, 81, 202, 0.8),
            0px 0px 10px rgba(41, 81, 202, 0.8),
            0px 0px 10px rgba(41, 81, 202, 0.8);
          font-style: italic;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;

          text-overflow: ellipsis;
          //   text-shadow: 0px 2px 2px rgba(2, 17, 20, 0.15);
          //   background: linear-gradient(
          //     0deg,
          //     rgba(27, 62, 175, 0.46) 0%,
          //     rgba(255, 255, 255, 0.46) 100%
          //   );
          //   -webkit-background-clip: text;
          //   -webkit-text-fill-color: transparent;
        }
      }

      .main_txt {
        display: flex;
        align-items: center;
        margin: 10px 0;
        //   justify-content: center;
        // letter-spacing: 1px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        font-size: 14px;
        color: #c6d2d8;
        line-height: 20px;
        width: 220px;
        height: 40px;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 2;
        // overflow: hidden;
        overflow: auto;
        // text-overflow: ellipsis;
      }

      .time {
        width: 180px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #c6d2d8;
        line-height: 16px;
      }
    }
  }

  .photo_item:nth-child(1) {
    margin-top: 0;
  }

  ::-webkit-scrollbar {
    width: 7px;
    // height: 4px;
    background-color: transparent;
  }

  /*定义滚动条轨道内阴影+圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
    // border-radius: 10px;
    background-color: rgba(0, 34, 66, 1);
  }

  /*定义滑块内阴影+圆角*/

  ::-webkit-scrollbar-thumb {
    // border-radius: 10px;
    -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
    background-image: linear-gradient(#00458a, #00458a);
  }
}

.text-area {
  height: 240px;
  pointer-events: auto;
  width: 100%;
  overflow-y: auto;

  // &::-webkit-scrollbar {
  //     width: 0;
  // }
}
</style>
